module.exports = __webpack_public_path__ + "img/whot.bfbf9c3d.png";